export default __webpack_public_path__ + "static/media/perrinita1.607804a5.jpg";